import { useEffect } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

import { connectApi } from 'libs/connectApi'

export const hasPermission = (permission, user) =>
  R.pathOr(false, ['permissions', permission], user)

export const Container = ({ children, permission, user }) => {
  useEffect(() => {
    if (!user.data) {
      user.callApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!hasPermission(permission, user.data)) {
    return null
  }

  return children
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  permission: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
}

export const HasPermission = connectApi({
  name: 'user',
  url: 'account/users/me/v2/',
  schema: '@userInfo',
  skip: true,
})(Container)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/HasPermission/index.js